/* T-0149 owner scope #2 — analytics for the renewed order flow (landing page + menu/extras/review page).
 *
 * Every event is pushed to window.dataLayer (GTM container GTM-PWRXKR8 forwards it to GA4 / Meta, the same way it
 * already forwards snippets/ga4-datalayer.liquid's view_item_list / quick_view) AND published as a Shopify custom
 * analytics event via Shopify.analytics.publish(name, payload) for the custom (spec) events.
 *
 * Meals live in LocalCart/localStorage, not /cart/add.js, so Shopify's native product_added_to_cart never fires per
 * meal; the explicit add_to_cart / remove_from_cart pushes here are the only signal.
 *
 * Conventions copied from ga4-datalayer.liquid: `{ ecommerce: null }` clear, then `{ event, ecommerce: { items } }`;
 * price in dollars, item_id = the product id as a string. No PII: never an email, name, address or the postcode's owner.
 */
(function () {
  'use strict';
  if (window.ThriveOF) return;
  window.dataLayer = window.dataLayer || [];

  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
  }

  /* A spec event: dataLayer push + Shopify.analytics.publish. */
  function track(name, params) {
    var p = { flow: 'renewed_order_flow' };
    Object.keys(params || {}).forEach(function (k) { if (params[k] !== undefined && params[k] !== null) p[k] = params[k]; });
    try { var o = { event: name }; Object.keys(p).forEach(function (k) { o[k] = p[k]; }); window.dataLayer.push(o); } catch (e) {}
    publish(name, p);
  }

  /* A GA4 / Meta ecommerce event (view_item_list, view_item, add_to_cart, remove_from_cart, begin_checkout). */
  function ecommerce(name, items, extra) {
    var ec = { currency: 'AUD', items: items || [] };
    Object.keys(extra || {}).forEach(function (k) { if (extra[k] !== undefined && extra[k] !== null) ec[k] = extra[k]; });
    try {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: name, ecommerce: ec });
    } catch (e) {}
  }

  /* One GA4 item from a page product record ({id, vid, title, price (cents), type}). */
  function item(p, qty, index) {
    var it = {
      item_id: String(p.id),
      item_name: p.title,
      item_variant: String(p.vid),
      price: Math.round(Number(p.price) || 0) / 100,
      quantity: qty == null ? 1 : qty
    };
    if (p.type) it.item_category = p.type;
    if (index != null) it.index = index;
    return it;
  }

  window.ThriveOF = { track: track, ecommerce: ecommerce, item: item };
})();
